import React, { useId } from 'react';

/**
 * Switch — on/off toggle (role="switch").
 *
 * Props:
 *   checked, onChange(nextBoolean), disabled
 *   label, hint: ReactNode
 *   size: 'sm' | 'md'
 */
const Switch = React.forwardRef(function Switch(
  { checked = false, onChange, disabled, label, hint, size = 'md', id, className = '' },
  ref,
) {
  const autoId = useId();
  const inputId = id || autoId;

  const control = (
    <button
      ref={ref}
      id={inputId}
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      className={`ps-switch ps-switch--${size}`}
      onClick={() => !disabled && onChange?.(!checked)}
    >
      <span className="ps-switch__thumb" aria-hidden="true" />
    </button>
  );

  if (!label && !hint) return control;

  return (
    <span className={`ps-switch-field ${disabled ? 'is-disabled' : ''} ${className}`.trim()}>
      {control}
      <label className="ps-switch-field__text" htmlFor={inputId}>
        {label && <span className="ps-switch-field__label">{label}</span>}
        {hint && <span className="ps-switch-field__hint">{hint}</span>}
      </label>
    </span>
  );
});

export default Switch;
